var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{class:{ option: true, active: _vm.active },on:{"click":function($event){return _vm.onClick()}}},[_vm._m(0),_vm._v("\n  "+_vm._s(_vm.option)+"\n")])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',[_c('img',{attrs:{"src":require("../../../../../assets/check.svg"),"alt":"check"}})])
}]

export { render, staticRenderFns }